import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import Profile from './profile-model'
import {
  CreateProfileAsync,
  DeleteProfileAsync,
  LoadProfilesAsync,
} from './profile-thunk'
const initialState: profileSliceState = {
  profile: [],
  selected_profile: '',
  is_loading_profile: false,
  is_creating_profile: false,
  is_deleting_profile: false,
}
export interface profileSliceState {
  profile: Profile[]
  selected_profile?: string
  is_loading_profile: boolean
  is_creating_profile: boolean
  is_deleting_profile: boolean
}
export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setSelectedprofile: (state, action) => {
      state.selected_profile = action.payload
    },
    clearStateprofile: (state) => {
      state.profile = []
      state.is_loading_profile = false
      state.is_creating_profile = false
      state.is_deleting_profile = false
    },
    mergeprofile: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_profile = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.profile = merge(state.profile, payload) as any
        }
      }
    },

    add_profile: (state, action) => {
      if (action.payload) {
        state.profile = [...state.profile, action.payload]
      }
    },
    set_profile: (state, action) => {
      let { key, value, id } = action.payload
      state.profile = state.profile.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProfilesAsync.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(LoadProfilesAsync.fulfilled, (state, action) => {
      state.is_loading_profile = false
      if (action.payload) {
        state.profile = action.payload
      }
    })
    builder.addCase(LoadProfilesAsync.rejected, (state) => {
      state.is_loading_profile = false
    })
    builder.addCase(CreateProfileAsync.pending, (state) => {
      state.is_creating_profile = true
    })
    builder.addCase(CreateProfileAsync.fulfilled, (state) => {
      state.is_creating_profile = false
    })
    builder.addCase(CreateProfileAsync.rejected, (state) => {
      state.is_creating_profile = false
    })
    builder.addCase(DeleteProfileAsync.pending, (state) => {
      state.is_deleting_profile = true
    })
    builder.addCase(DeleteProfileAsync.fulfilled, (state, action) => {
      state.is_deleting_profile = false
      if (state.profile) {
        state.profile = state.profile.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteProfileAsync.rejected, (state) => {
      state.is_deleting_profile = false
    })

    builder.addCase(autoThunks.add_profile.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(autoThunks.add_profile.fulfilled, (state, action) => {
      state.is_loading_profile = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.add_profile.rejected, (state) => {
      state.is_loading_profile = false
    })

    builder.addCase(autoThunks.get_profile.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(autoThunks.get_profile.fulfilled, (state, action) => {
      state.is_loading_profile = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.get_profile.rejected, (state) => {
      state.is_loading_profile = false
    })

    builder.addCase(autoThunks.update_profile.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(autoThunks.update_profile.fulfilled, (state, action) => {
      state.is_loading_profile = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.update_profile.rejected, (state) => {
      state.is_loading_profile = false
    })

    builder.addCase(autoThunks.get_profiles_list.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(autoThunks.get_profiles_list.fulfilled, (state, action) => {
      state.is_loading_profile = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.get_profiles_list.rejected, (state) => {
      state.is_loading_profile = false
    })

    builder.addCase(autoThunks.get_profiles.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(autoThunks.get_profiles.fulfilled, (state, action) => {
      state.is_loading_profile = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.get_profiles.rejected, (state) => {
      state.is_loading_profile = false
    })

    builder.addCase(autoThunks.get_profiles_for_edit.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(
      autoThunks.get_profiles_for_edit.fulfilled,
      (state, action) => {
        state.is_loading_profile = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_profiles_for_edit.rejected, (state) => {
      state.is_loading_profile = false
    })

    builder.addCase(autoThunks.load_profiles.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(autoThunks.load_profiles.fulfilled, (state, action) => {
      state.is_loading_profile = false
      handleResult(action, state)
    })
    builder.addCase(autoThunks.load_profiles.rejected, (state) => {
      state.is_loading_profile = false
    })

    builder.addCase(autoThunks.load_profiles_watch.pending, (state) => {
      state.is_loading_profile = true
    })
    builder.addCase(
      autoThunks.load_profiles_watch.fulfilled,
      (state, action) => {
        state.is_loading_profile = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_profiles_watch.rejected, (state) => {
      state.is_loading_profile = false
    })
  },
})

function handleResult(action: any, state: profileSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_profile = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.profile = merge(state.profile, payload) as any
    }
  }
}

export const {
  clearStateprofile,
  setSelectedprofile,
  set_profile,
  mergeprofile,
  add_profile,
} = profileSlice.actions

export const get_profile =
  (id?: string) =>
  (state: {
    profile: {
      profile: Profile[]
    }
  }): Profile | null => {
    let temp = state?.profile?.profile?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.profile?.profile[0] || null
  }
export const get_selected_profile = (state: {
  profile: profileSliceState
}): Profile | null => {
  let id = state?.profile?.selected_profile
  let temp = state?.profile?.profile?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_profile = (state: {
  profile: {
    profile: Profile[]
  }
}): Profile[] => {
  let temp = state?.profile?.profile
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_profile_busy = (state: { profile: profileSliceState }) => {
  return (
    state?.profile.is_deleting_profile ||
    state?.profile.is_loading_profile ||
    state?.profile.is_creating_profile
  )
}
export const is_deleting_profile_busy = (state: {
  profile: profileSliceState
}) => {
  return state?.profile.is_deleting_profile
}
export const is_loading_profile_busy = (state: {
  profile: profileSliceState
}) => {
  return state?.profile.is_loading_profile
}
export const is_creating_profile_busy = (state: {
  profile: profileSliceState
}) => {
  return state?.profile.is_creating_profile
}

export default profileSlice.reducer
